<template>
  <div class="d-flex sw_wrapper">
    <b-card>
      <b-card-title>
        <span class="point">12/100</span>
        <button v-hotkey="keymap" v-show="false">next</button>
      </b-card-title>
      <b-card-body>
        <div class="engcard d-flex">
          <div class="word_wrapper">
            <div ref="word" class="word">
              <div ref="engref" v-html="divideAll" />
              <div class="desc">{{ currentItem.ts }}</div>
              <div class="example">{{ currentItem.ex }}</div>
            </div>
          </div>
          <div class="buttons">
            <b-button @click="setLevel(1)" variant="success">EASY</b-button>
            <b-button @click="setLevel(2)" variant="warning">NORMAL</b-button>
            <b-button @click="setLevel(3)" variant="danger">remind me</b-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import * as R from "ramda";
export default {
  data() {
    return {
      items: [
        {
          eng: "apple",
          ts: "사과",
          ex: "i love apples",
        },
        {
          eng: "banana",
          ts: "사과",
          ex: "i love banana",
        },
        {
          eng: "watermelon",
          ts: "수박",
          ex: "i love watermelon",
        },
        {
          eng: "kiwi",
          ts: "키위",
          ex: "i love kiwi",
        },
      ],
      idx: 0,
    };
  },
  computed: {
    currentItem() {
      return this.items[this.idx];
    },
    divideAll() {
      let $this = this;
      let idx = 0;
      return R.map((item) => {
        let color = "#264653";
        if (idx == 2) {
          color = "white";
        }
        idx++;
        return `<span style='color:${color};'>` + item + "</span>";
      }, $this.items[this.idx].eng).join("");
    },
    keymap() {
      return {
        "ctrl+l": this.moveL,
        "ctrl+p": this.moveR,
        left: this.moveL,
        right: this.moveR,
      };
    },
  },
  methods: {
    moveR() {
      let $this = this;
      this.$anime({
        targets: ".word",
        translateX: "-600px",
        easing: "linear",
        opacity: 0.0,
        endDelay: 0,
        duration: 500,
        begin: function (anim) {},

        complete: function (anim) {
          if ($this.idx > $this.items.length - 2) {
            $this.idx = 0;
          } else {
            $this.idx = $this.idx + 1;
          }

          anim.set(".word", {
            opacity: 1.0,
            translateX: "0",
          });
        },
      });
    },
    moveL() {
      let $this = this;
      this.$anime({
        targets: ".word",
        translateX: "600px",
        easing: "spring(1, 70, 30, 0)",
        opacity: 0.0,
        endDelay: 0,
        complete: function (anim) {
          if ($this.idx > $this.items.length) {
            $this.idx = 0;
          } else {
            $this.idx = $this.idx - 1;
          }
          anim.set(".word", {
            opacity: 1.0,
            translateX: "0",
          });
        },
      });
    },
    setLevel(lvl) {
      this.moveR();
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.sw_wrapper {
  height: calc(100vh - 50px);
  justify-content: center;
  align-items: center;
  .point {
    color: $color2;
    font-size: 0.9em;
  }
  .engcard {
    justify-content: center;
    align-items: center;
    min-height: 70vh;
    min-width: 80vw;
    flex-direction: column;

    .word_wrapper {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    @media screen and (min-width: 601px) {
      .word {
        font-size: 10rem;
        color: $color1;
        span.bl {
          color: white;
        }

        .desc {
          font-size: 2rem;
          text-align: center;
        }
        .example {
          font-size: 2rem;
          text-align: center;
          color: $gray500;
        }
      }
    }
    @media screen and (max-width: 600px) {
      .word {
        font-size: 5rem;
        color: $color1;
        span.bl {
          color: white;
        }

        .desc {
          font-size: 1.5rem;
          text-align: center;
          font-weight: 700;
        }
        .example {
          font-size: 1.4rem;
          text-align: center;
          color: $gray500;
        }
      }
      .buttons {
        flex-basis: 50px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>